import * as Yup from 'yup';
export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email('Please enter a valid email address')
    .max(150, 'Email cannot exceed 150 characters')
    .required('Email is required'),

  first_name: Yup.string()
    .trim()
    .max(150, 'First name cannot exceed 150 characters')
    .required('First name is required'),

  last_name: Yup.string()
    .trim()
    .max(150, 'Last name cannot exceed 150 characters')
    .required('Last name is required'),

  company: Yup.string()
    .trim()
    .max(150, 'Company cannot exceed 150 characters')
    .transform(value => (value && value.trim() ? value : 'no company'))
    .default('no company'),

  password: Yup.string()
    .trim()
    .min(8, 'Password must be at least 8 characters')
    .max(200, 'Password cannot exceed 200 characters')
    .required('Password is required'),

  confirm_password: Yup.string()
    .trim()
    .min(8, 'Password must be at least 8 characters')
    .max(200, 'Password cannot exceed 200 characters')
    .required('Please confirm your password')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match')
});

export const _initialValues = {
  email: '',
  first_name: '',
  last_name: '',
  company: '',
  password: '',
  confirm_password: ''
};
